import classNames from 'classnames';
import { maxWidth, primaryFont, retina, wMedium, maxWidth1300 } from 'constants/utilsStyles';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';

const ButtonWrapper = styled.div<{ bgColor?: string, fColor?: string, borderColor?: string, separatorColor?: string }>`
  &.iconModeWrapper {
   padding: 10px;
   @media all and (max-width: ${maxWidth1300}) {
    padding: 6px 10px 9px;
   }
  }
  background-color: ${(props) => props?.bgColor};
  border: 1px solid ${(props) => props?.borderColor};
  border-radius: 8px;
  padding: 8px 12px 6px 16px;  
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  .btn-text {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 18px;
    color: ${(props) => props?.fColor};
  }
  .right-separator {    
    margin: 0 5px 0 9px;
    height: 20px;
    border-right: 0.50px solid ${(props) => props.separatorColor};
  }
  svg {    
    width: 14px;
    min-width: 14px;
    height: 12px;
  }
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 4px 10px 4px 14px;
    .btn-text {
      font-size: 13px;
      line-height: 14px;
    }
  }
  @media all and (max-width: ${maxWidth1300}) {
    padding: 7px 10px 5px 10px;
    .btn-text {
      font-size: 12px;
      line-height: 14px;
    }
    .right-separator {  
      height: 16px;
    }
    svg {
      width: 12px;
      min-width: 12px;
      height: 12px;
    }
  }

`;

interface GlobalButtonType {
  rightIcon?: object,
  bgColor?: string,
  fColor?: string,
  borderColor?: string,
  separatorColor?: string,
  iconMode?: boolean,
  noSeparator?: boolean,
};

type Props = {
  title?: string,
  globalButtonData?: GlobalButtonType,
  btnClassName?: string,
  onClick?: () => void,

} & typeof defaultProps;

const defaultProps = {
  title: '',
  globalButtonData: {},
  btnClassName: '',
  onClick: () => { },
};

const GlobalButton = function GlobalButton(props: Props) {
  const { globalButtonData, btnClassName, title, onClick } = props;
  const { rightIcon, bgColor, fColor, borderColor, iconMode, separatorColor, noSeparator } = globalButtonData;
  return (
    <Tooltip title={iconMode ? title : undefined}>
      <ButtonWrapper
        className={classNames(`global-btn ${btnClassName}`, { iconModeWrapper: iconMode })}
        bgColor={bgColor}
        fColor={fColor}
        borderColor={borderColor}
        separatorColor={separatorColor}
        onClick={onClick}
      >
        {iconMode ? null : (
          <>
            <span className='btn-text'>{title}</span>
            {noSeparator ? null : <span className='right-separator' />}
          </>
        )}
        {rightIcon}
      </ButtonWrapper>
    </Tooltip>
  );
};
GlobalButton.defaultProps = defaultProps;
export default GlobalButton;
